export default __webpack_public_path__ + "static/Artboard-7-c6b51f8fc420ceac19ac62a752d25f6d.webp";